import { Button } from "@heroui/react";
import { motion } from "framer-motion";
import { LuFolderOpen } from "react-icons/lu";
import { twMerge } from "tailwind-merge";

const EmptyState = ({
    title = "No Data Found",
    description = "There is no data to display at all",
    icon: Icon = LuFolderOpen,
    iconSize = 64,
    iconClassName,
    actionLabel,
    onAction,
}) => {
    return (
        <div className="flex h-full w-full flex-col items-center justify-center p-8 text-center">
            <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, ease: "easeOut" }}
                className="relative mb-6"
            >
                {/* Glow Effect */}
                <div className="from-primary/20 to-secondary/20 absolute inset-0 bg-linear-to-tr blur-2xl filter" />

                {/* Icon */}
                <div className="relative">
                    <Icon
                        size={iconSize}
                        strokeWidth={1.5}
                        className={twMerge("text-default-300", iconClassName)}
                    />
                </div>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2, duration: 0.5 }}
                className="max-w-xs"
            >
                <h3 className="text-default-700 text-lg font-semibold">
                    {title}
                </h3>
                <p className="text-default-500 mt-2 text-sm leading-relaxed">
                    {description}
                </p>
            </motion.div>

            {onAction && actionLabel && (
                <motion.div
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.4, duration: 0.5 }}
                    className="mt-6"
                >
                    <Button color="primary" variant="flat" onPress={onAction}>
                        {actionLabel}
                    </Button>
                </motion.div>
            )}
        </div>
    );
};

export default EmptyState;
